import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation }    from 'react-router-dom';

import './style.scss';

import Preloader                 from '../../components/containers/preloader';
import Meta                      from '../../components/meta';
import PageHeader                from '../../components/pageHeader';
import { useCommon }             from '../../providers/common';
import { useDealerRequestModal } from '../../providers/dealerRequest';

import renderStaticSection from '../_common/utils/renderStaticSection';
import Notfound            from '../notfound/components/Notfound';

const Dealer = function() {
  const {
          getPageData,
          loading,
          pages,
        }             = useCommon();
  const { pathname }  = useLocation();
  const { t }         = useTranslation();
  const { showModal } = useDealerRequestModal();

  const page = useMemo(() => pages.find((page) => `/${page.urlKey}` === pathname), [pages, pathname]);

  const getInitialState = React.useCallback(() => {
    if (!page.hasOwnProperty('content') && !loading) {
      getPageData(pathname);
    }
  }, [getPageData, page, loading]);

  const sections = useMemo(() => {
    const { content: Content } = page;

    let content;
    try {
      content = JSON.parse(Content);
    } catch (e) {
    }

    if (!loading) {
      if (!content && !loading) {
        return (
          <Notfound />
        );
      }

      return content.SECTIONS.map((section, index) => renderStaticSection(section, index));
    }

  }, [loading, page, renderStaticSection]);

  React.useEffect(() => {
    getInitialState();
    if (!isSSR()) {
      scrollTo({
        top:  0,
        left: 0,
      });
    }
  }, []);

  return (
    <>
      <div className={'page-content'}>
        <Meta {...page?.meta} />
        <PageHeader>{page.label}</PageHeader>
        <main className={page.template}>
          <section className={'dealer'}>
            <article>
              {sections}
            </article>
            <button
              className={'btn fill'}
              onClick={showModal}
            >{t('dealer.questionnaire')}</button>
          </section>
        </main>
      </div>
      {loading && (
        <Preloader />
      )}
    </>
  );
};

export default Dealer;